import { Dialog, DialogContent } from "@mui/material";
import React from "react";

interface IProps {
  url: string;
  onClose: () => void;
}

const ImagePreview: React.FC<IProps> = ({ url, onClose }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsOpen(url && url.length > 0);
  }, [url]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        onClose();
      }}
      maxWidth="xl"
      keepMounted
    >
      <DialogContent>
        <img src={url} width="100%" height="auto" alt="" />
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreview;
